/**
*
* Button
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import ButtonWrapper from './styles/ButtonWrapper';


class Button extends React.PureComponent {
  
  render() {

    const { 
      title, 
      isSecondary,
      className,
      hasIcon
    } = this.props;

    return (
      <ButtonWrapper 
        isSecondary={isSecondary}
        onClick={this.props.handleClick}
        disabled={this.props.disabled}
        className={className}
      >
        { hasIcon ? (
          <img style={{ marginRight: "7.76px" }} src="/assets/img/arrow-back.svg"/>
        ) : ("") }
        {title}
      </ButtonWrapper>
    )
  }
};

Button.propTypes = {
  title: PropTypes.string
};

export default Button;
